import React from 'react';
import { useLocation } from 'react-router-dom';
import ButtonOpenStoreCounter from './ButtonOpenStoreCounter';
import { useCartContext } from '../../Contexts/CartContext';
import { formatCartId } from '../../Utils/Formatters';
import { useStoreContext } from '../../Contexts/StoreContext';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import { useStoreHook } from '../../Hooks/StoreHook';
import ButtonPrimary from '../Form/ButtonPrimary';
import { TbArrowBigRightFilled } from 'react-icons/tb';
import Button from '../Form/Button';
import BoxContentStoreOrderTypeHeader from './BoxContentStoreOrderTypeHeader';
import BoxContentSearchHeader from './BoxContentSearchHeader';
import HeaderLogo from './HeaderLogo';
import { HiBars3 } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';
import { useCheckoutContext } from '../../Contexts/CheckoutContext';
import { useOrderHook } from '../../Hooks/OrderHook';

const HeaderStoreCounter = () => {

    const { t } = useTranslation();
    const location = useLocation();
    const { cartDisplay, cartFinished, setShowCartConference, cartConference, getTotalQuantityProductsInConference } = useCartContext();
    const { currentStore, cashier } = useStoreContext();
    const { isMobile, setShowMainMenu } = useLayoutContext();
    const { getLinkToHome } = useStoreHook();
    const { handleShowCart} = useOrderHook();
    const { order } = useCheckoutContext();

    const isHome = location.pathname === getLinkToHome();
    const isProductPage = new RegExp(`^${getLinkToHome().replace('/', '\\/')}/produto/`).test(location.pathname);

    return (
        <>
            <header id="boxHeader" className="flex flex-col w-full h-20 justify-between sticky top-0 z-30 bg-custom-header text-custom-header-text">
                <section className='flex h-full p-4 justify-center shadow-sm shadow-black/5'>
                    <div className={`flex items-center justify-between w-full md:max-w-[1460px] gap-4 md:gap-6`}>

                        {/* LOGO */}
                        <HeaderLogo className='min-h-20' />

                        <div className='flex items-center justify-end w-full gap-4 md:gap-6'>

                            {/* SEARCH */}
                            <BoxContentSearchHeader show={currentStore && (isHome || isProductPage)} />

                            <div className="flex items-center gap-2 md:gap-4 h-full">
                                {/* ORDER TYPE CHANGE BUTTON / CurrentAddress / CurrentStore  */}
                                <BoxContentStoreOrderTypeHeader sizeButton={22} />

                                {cashier && currentStore.customer_self_attendance &&
                                    <>
                                        {!isMobile && cartDisplay
                                            ?
                                                cartConference.length > 0 ?
                                                    <div className='flex items-center gap-1'>
                                                        <ButtonPrimary onClick={() => setShowCartConference(true)} className='relative text-nowrap w-full md:max-w-max gap-2 items-center justify-between'>
                                                            <span className='flex gap-1 items-center'>
                                                                <TbArrowBigRightFilled size={20} className='animate-side text-white' />
                                                                <span>{getTotalQuantityProductsInConference(cartConference) > 1 ? `${getTotalQuantityProductsInConference(cartConference)} ${t('layout.item_label_plural')}` : `${getTotalQuantityProductsInConference(cartConference)} ${t('layout.item_label_singular')}`}</span>
                                                            </span>
                                                        </ButtonPrimary>
                                                    </div>
                                                :
                                                    <ButtonPrimary outline onClick={() => handleShowCart(order)} className='hidden md:flex ring-inset shadow-reverse-md md:shadow-none'>
                                                        <span className='font-extrabold text-nowrap'>nº { formatCartId(cartDisplay?.display_id || cartDisplay?.id) }</span>
                                                    </ButtonPrimary>
                                            :
                                                <div className='w-auto hidden md:flex text-sm'>
                                                    <ButtonOpenStoreCounter className='text-nowrap' forceLabel label={cartFinished ? '' : 
                                                        <div className='flex flex-col'>
                                                            <span className='leading-none text-xl font-black leading-none'>{t('menu.mobile.store_counter.button_open_label')}</span>
                                                            <span className='text-xs opacity-75 font-medium leading-none'>{t('store_counter.name')}</span>
                                                        </div>} />
                                                </div>
                                        }
                                    </>
                                }
                            </div>

                            {(!isMobile) && ( //* isAuthenticated somente se nao tiver buttonsViewMode
                                <div className="flex items-center gap-2">
                                    {/* <ButtonsViewMode /> */}
                                    <Button rounded onClick={() => setShowMainMenu(true)}>
                                        <div><HiBars3 size={22} /></div>
                                    </Button>
                                </div>
                            )}

                        </div>
                    </div>
                </section>

            </header>
        </>
    )
}

export default HeaderStoreCounter;
